<template>
  <div class="pinwall__postImage">
    <img
      :style="translateY ? `transform: translateY(-${translateY}%)` : ''"
      width="100%"
      v-if="image"
      :src="image.source"
    />
    <svg
      v-else
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="`0 0 1280 ${width / proportion}`"
    >
      <rect
        x="0"
        y="0"
        width="1280"
        :height="`${width / proportion}`"
        fill="#000"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "PostImage",
  data: () => {
    return {
      width: 1280
    };
  },
  props: {
    image: {
      default: null,
      type: Object
    },
    proportion: {
      default: 1.77777,
      type: Number
    },
    translateY: {
      default: null,
      type: Number
    }
  }
};
</script>
